import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorDialogInput } from 'app/c/error-dialog/error-dialog';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import { Subject } from 'rxjs';
import { use } from 'typescript-mix';
import { ChannelASRPriotiyOffset } from './channel-asr-priority-offset';
import { ChannelStreams } from './channel-streams';
import { Channels } from './channels';
import { Fragments, FragmentsWithProblem } from './fragments';
import { Groups } from './groups';
import { LangModels } from './lang-models';
import { Schedules } from './schedules';
import { Servers } from './servers';
import { UserGroups } from './user-groups';
import { UserSchedules } from './user-schedule';
import { UserSelf } from './user-self';
import { UsersInCurrentGroup } from './users-in-current-group';
import { UsersInGroup } from './users-in-group';

export const SNAPSHOT = true;

export interface DataService
  extends Groups,
  UserGroups,
  UsersInCurrentGroup,
  Schedules,
  UserSelf,
  UserSchedules,
  UsersInGroup,
  LangModels,
  ChannelASRPriotiyOffset { }

@Injectable({
  providedIn: 'root',
})
export class DataService {
  error = new Subject<ErrorDialogInput>();
  readonly fragmentsWithProblem;
  readonly fragments;
  readonly channelStreams;
  readonly channels;
  readonly servers;

  @use(
    Groups,
    UserGroups,
    UsersInCurrentGroup,
    Schedules,
    UserSelf,
    UserSchedules,
    UsersInGroup,
    LangModels,
    ChannelASRPriotiyOffset,
  )
  this: DataService;

  constructor(public http: HttpClient) {
    this.initGroups();
    this.initUserGroups();
    this.initUsersInCurrentGroup();
    this.initSchedules();
    this.initUserSchedules();
    this.initUserSelf();
    this.initLangModels();
    this.channels = new Channels(this.http, env.graphql);
    this.servers = new Servers(this.http, env.graphql);
    this.fragmentsWithProblem = new FragmentsWithProblem(this.http, env.graphql);
    this.fragments = new Fragments(this.http, env.graphql);
    this.channelStreams = new ChannelStreams(this.http, env.graphql);
  }

  getChannelTypes() {
    return Object.values(GraphQL.ChannelTypes);
  }
}
